import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'
import { URLPrefix } from 'service/url'

import { ReportTemplateJSON, ScheduleMeta } from '../domain/Report'
import { IReportTemplateJSON } from '../domain/ReportTemplateModel'

export class ReportService {
  http: HttpBaseApiWrapper
  baseURL = '/reports'
  constructor(http: HttpBaseApiWrapper) {
    this.http = http
  }

  getAll(): Promise<ReportTemplateJSON[]> {
    return this.http.get(`${this.baseURL}`, {
      urlPrefix: URLPrefix.Root,
    })
  }

  get(id: string): Promise<IReportTemplateJSON> {
    return this.http.get(`${this.baseURL}/${id}`, {
      urlPrefix: URLPrefix.Root,
    })
  }

  create(report: Partial<IReportTemplateJSON>): Promise<void> {
    return this.http.post(`${this.baseURL}`, report, {
      urlPrefix: URLPrefix.Root,
    })
  }

  update(id: string, report: Partial<IReportTemplateJSON>): Promise<void> {
    return this.http.put(`${this.baseURL}/${id}`, report, {
      urlPrefix: URLPrefix.Root,
    })
  }

  delete(report: Partial<IReportTemplateJSON>): Promise<void> {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return this.http.delete(`${this.baseURL}/${report._id}`, report, {
      urlPrefix: URLPrefix.Root,
    })
  }

  generate(id: string, format?: string): Promise<void> {
    return this.http.post(`${this.baseURL}/generate/${id}`, format ? { format } : undefined, {
      urlPrefix: URLPrefix.Root,
    })
  }

  public schedule(id: string, meta: ScheduleMeta): Promise<void> {
    return this.http.post(
      `${this.baseURL}/schedule/${id}`,
      { meta },
      {
        urlPrefix: URLPrefix.Root,
      }
    )
  }
}
